import { Button, type ButtonProps } from "@mui/joy";
import type { ReactNode } from "react";

interface PrimaryButtonProps extends ButtonProps {
  children: ReactNode;
}

export const PrimaryButton = ({
  children,
  sx,
  ...props
}: PrimaryButtonProps) => {
  return (
    <Button
      color="primary"
      {...props}
      sx={{
        borderRadius: "8px",
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};
